import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { route } from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import User from "../../../../services/user";
import { Overlay } from "../user/menu-popup";
import { CloseIcon } from "../../utils/icons.jsx";

export default function BonusNotificationModal() {
    const [visible, setVisible] = useState(false);
    const [bonusAmount, setBonusAmount] = useState(0);

    useEffect(() => {
        const showBonusNotification = () => {
            setBonusAmount(User.bonus());
            setVisible(true);
        };

        User.addBonusNotificationListener(showBonusNotification);

        return () => {
            User.removeBonusNotificationListener(showBonusNotification);
        };
    }, []);

    const handleClose = () => {
        setVisible(false);
    };

    const handleGoToPromo = () => {
        route("/promo");
        handleClose();
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'ETB' }).format(amount);
    };

    if (!visible) {
        return null;
    }

    return (
        <Overlay onClick={handleClose}>
            <div class="bg-white rounded-lg shadow-lg text-center mx-auto w-full max-w-screen-sm flex-none">
                <div class="bg-blue-whale-500 p-4 rounded-t-lg relative">
                    <h2 class="text-2xl font-bold text-white"><Trans>Congratulations!</Trans></h2>
                    <button class="absolute top-2 right-2 text-white" onClick={handleClose}><CloseIcon class="h-4 fill-current" /></button>
                </div>
                <div class="p-6">
                    <p class="mb-4 text-lg"><Trans>You have received a bonus of</Trans>:</p>
                    <div class="border border-gray-300 rounded-lg p-4 inline-block">
                        <p class="text-4xl font-bold text-slate-700">{formatCurrency(bonusAmount)}</p>
                    </div>
                    <div class="flex justify-center mt-4">
                        <button class="bg-blue-whale-500 text-white px-6 py-3 rounded-full mr-2 hover:bg-blue-whale-600 transition duration-300" onClick={handleGoToPromo}>
                            {window.Translation("Show Promo")}
                        </button>
                    </div>
                </div>
            </div>
        </Overlay>
    );
}
